export const reasonsToToggle = {
  escape: 'escape',
  clickOutside: 'clickOutside',
  clickItem: 'clickItem',
  clickAnchor: 'clickAnchor'
};

/**
 * Value used to ensure the `Dropdown` has a
 * minimum height when it doesn't fit on the screen.
 *
 * It's composed by:
 *
 * 1. + The `padding-top` of the `Dropdown`: 16px (--size-spacing-04)
 * 2. + The average size of an `Dropdown.Header`: 52px
 * 3. + The average size of 4 `Dropdown.Item`: 160px
 * 4. + The average size of an `Dropdown.Footer`: 61px
 * 5. + The `padding-bottom` of the `Dropdown`: 16px (--size-spacing-04)
 */
export const MIN_HEIGHT = 305;

/**
 * Value to set the `Dropdown` max height.
 *
 * This value is indicated by Design Ops team.
 * Its represents the size of 8 - 9 items.
 */
export const MAX_HEIGHT = 360;